export default "__VITE_ASSET__BLg9uKLr__"